var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leadgods-styles-container"},[_c('button',{staticClass:"leadgods-styles",on:{"click":_vm.linkGenerator}},[_c('img',{attrs:{"src":_vm.imgLink,"alt":"imagen de marketpago"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a83b404","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/paymentsMethods/leadgods.vue
// module id = 1235
// module chunks = 43